module.exports = __webpack_public_path__ + "static/media/stedelijk.319a4b63.jpg";